import type { ApiProxyClient } from '../../types';
import { getOrders } from './getOrders';

export const ordersApi: ApiProxyClient['orders'] = {
    getOrders,
};
